export default {
    init() {
        const buttons = document.querySelectorAll('[data-button]')

        buttons.forEach(button => {
            const delay = button.getAttribute('data-button')
            const background = button.querySelector('[data-background]')
            const hover = button.querySelector('[data-hover]')
            const label = button.querySelector('[data-label]')

            const animateIn = gsap.timeline({
                scrollTrigger: {
                    trigger: button,
                    toggleActions: 'play none play none',
                },
                delay: delay,
                onComplete: () => {
                    button.classList.add('btn--loaded')
                },
            })

            animateIn
                .to(hover, {
                    y: '0%',
                    duration: 0.5,
                    ease: 'circ.inOut',
                })
                .to(background, {
                    x: '0%',
                    duration: 0.5,
                    ease: 'circ.inOut',
                })
                .to(label, {
                    opacity: 1,
                    duration: 0.5,
                })
        })
    },
}
